import api from "../globals/axios";

export const getBiocharPlants = async () => {
  let url = "biochar/get-biochar-plants/";
  const response = await api.get(url);
  return response.data;
};
